<template>
  <div>
    <div id="payment-method-config-list">
      <vs-table
        noDataText="Nenhum Fluxo Encontrado"
        ref="table"
        pagination
        :max-items="itemsPerPage"
        :data="itens"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div >
            <vs-button
              v-if="$can($actionsDefault.Escrita, subjectPermission)"
              @click="openModal()"
              color="primary"
              icon="add_circle_outline"
              class="h-12 mr-4 flex items-center justify-center px-4"
            >
              Cadastrar
            </vs-button>
          </div>
          <SelectPagination
            v-if="itens.length > 0"
            :currentPage="currentPage"
            :itemsPerPage="itemsPerPage"
            :length="totalCount"
            @update="updateSelectPagination"
          />
        </div>
        <template slot="thead">
          <vs-th style="width: 20%">Nome</vs-th>
          <vs-th style="width: 20%">Tipo de pagamento</vs-th>
          <vs-th style="width: 20%">Tipo de Apólice</vs-th>
          <vs-th style="width: 20%">Ativo</vs-th>
          <vs-th style="width: 20%">Ações</vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody>
          <vs-tr
            :key="indexPaymentMethod"
            v-for="(paymentMethodConfig, indexPaymentMethod) in data"
          >
            <vs-td class="nowrap">
              <p>{{ paymentMethodConfig.name }}</p>
            </vs-td>
            <vs-td>
              <vs-chip color="primary" class="font-bold">
                {{ getPaymentMethodName(paymentMethodConfig.paymentMethodId) }}
              </vs-chip>
            </vs-td>
            <vs-td>
              <p>{{ getPolicyCreationTypeLabel(paymentMethodConfig.policyCreationType) }}</p>
            </vs-td>
            <vs-td>
              <vs-chip :color="paymentMethodConfig.isActive ? 'success' : 'danger'" class="font-bold">
                {{ paymentMethodConfig.isActive ? "Ativo" : "Inativo" }}
              </vs-chip>
            </vs-td>
            <vs-td>
              <div class="vx-row">
                <div
                  class="vx-col"
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                >
                  <vs-button
                    v-tooltip="'Editar Configuração de Pagamento'"
                    radius
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="d-inline ml-2"
                    @click="editPaymentMethodConfig(paymentMethodConfig)"
                  ></vs-button>
                  <vs-button
                    v-tooltip="'Excluir Configuração de Pagamento'"
                    radius
                    color="danger"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-trash"
                    class="d-inline ml-2"
                    @click="confirmDelete(paymentMethodConfig)"
                  ></vs-button>
                </div>
              </div>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>

    <PaymentMethodConfigModal
      :isOpen="isModalOpen"
      :paymentMethodConfig="selectedPaymentMethodConfig"
      @close="closeModal"
      @save="handleSave"
    />

    <Modal
      :active="isDeleteModalOpen"
      title="Confirmação de Exclusão"
      @close="isDeleteModalOpen = false"
    >
      <div>
        <p>Tem certeza que deseja excluir a configuração de pagamento <strong>{{ paymentMethodConfigToDelete && paymentMethodConfigToDelete.name }}</strong>?</p>
      </div>
      <div class="delete-modal-buttons">
        <vs-button @click="deletePaymentMethodConfig" color="danger" block>
          Excluir
        </vs-button>
        <vs-button @click="isDeleteModalOpen = false" color="dark" outline block>
          Cancelar
        </vs-button>
      </div>
    </Modal>
  </div>
</template>


<script>
import paymentMethodConfigApi from "../../../../../services/payment.method.config.api";
import PaymentMethodConfigModal from "./PaymentMethodConfigModal.vue";
import Modal from "../../../../../components/Modal.vue";
import {POLICY_CREATION_TYPE} from "../../../../../constants/tipo.apolice";
import {PAYMENT_METHODS} from "../../../../../utils/constants";
import SelectPagination from "../../../../../utils/list/header/SelectPagination.vue";
import notify from "../../../../../utils/notify";

export default {
  name: "PaymentMethodConfigList",
  props: ["subjectPermission"],
  components: {SelectPagination, Modal, PaymentMethodConfigModal },
  data() {
    return {
      isModalOpen: false,
      isDeleteModalOpen: false,
      paymentMethodConfigToDelete: null,
      itens: [],
      itemsPerPage: 50,
      currentPage: 1,
      totalCount: 0,
      selectedPaymentMethodConfig: null,
    };
  },
  mounted() {
    this.getPaymentMethodConfigs();
  },
  methods: {
    updateSelectPagination(value) {
      this.currentPage = 1;
      this.itemsPerPage = value;
    },
    getPolicyCreationTypeLabel(value) {
      const found = Object.values(POLICY_CREATION_TYPE).find(
          (type) => type.value.toLowerCase() === value.toLowerCase()
      );
      return found ? found.label : value;
    },

    getPaymentMethodName(id) {
      const method = Object.values(PAYMENT_METHODS).find(m => m.id === id);
      return method ? method.name : id;
    },

    async getPaymentMethodConfigs() {
      this.itens = await paymentMethodConfigApi.getPaymentMethodConfigs();
      this.totalCount = this.itens.length;
    },

    handleSave() {
      this.getPaymentMethodConfigs();
      this.closeModal();
    },

    editPaymentMethodConfig(paymentMethodConfig) {
      this.selectedPaymentMethodConfig = { ...paymentMethodConfig };
      this.isModalOpen = true;
    },

    openModal(paymentMethodConfig = null) {
      this.selectedPaymentMethodConfig = paymentMethodConfig;
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },

    confirmDelete(paymentMethodConfig) {
      this.paymentMethodConfigToDelete = paymentMethodConfig;
      this.isDeleteModalOpen = true;
    },

    async deletePaymentMethodConfig() {
      try {
        await paymentMethodConfigApi.deletePaymentMethodConfig(this.paymentMethodConfigToDelete.id);
        notify.notifySuccess(
          this.$vs,
          `Método de pagamento ${this.paymentMethodConfigToDelete.name} foi excluído com sucesso`,
        );

        await this.getPaymentMethodConfigs();
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Erro ao excluir paymentMethod. Tente novamente',
        );
      } finally {
        this.isDeleteModalOpen = false;
        this.paymentMethodConfigToDelete = null;
      }
    },
  },
};
</script>

<style>
.delete-modal-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  gap: 16px;
}
#payment-method-config-list {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px 8px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
      .error-border {
        border: 2px solid orange;
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
  .vs-button.includeIcon {
    float: left;
    margin-right: 5px;
  }
}
</style>
